<template>
  <div class="notificationDetails">
    <div class="details">
      <div v-if="aggregate && count > 0" @click="$emit('showAggregation')" class="aggregationLink" />
      <div class="sourceName" :class="{ mbpAi: notification.sourceName === 'Marketbit.pro Trades AI' }"
        v-if="!isRow && feedType !== 'news'"><i v-if="notification.sourceName === 'Marketbit.pro Trades AI'"
          class="ri-sparkling-line" /> {{ notification.sourceName }}
      </div>
      <span v-if="!isRow && feedType !== 'news'" class="sourceName">@</span>
      <div class="sourceName" v-if="!isRow">{{ formatDateTime(notification.datetime) }}</div>

    </div>

    <div class="details">
      <div class="translate" style="margin: 0; background: var(--opacityRed)" v-if="isSpecial === 'latestBreaking'"
        @click="() => { }"><i class="ri-stack-line" /> {{ dictionary.buttons.readMore }}
      </div>
      <div class="translate" style="background: var(--opacityPurple)" v-if="isSpecial === 'wiim'" @click="() => { }"><i
          class="ri-stack-line" /> {{ dictionary.buttons.readMore }}
      </div>

      <div class="translate"
        style="margin: 0; background: var(--lightYellowOpacity); color: var(--lightYellow); cursor: pointer"
        v-if="aggregate && count > 0" @click="$emit('showAggregation')"><i class="ri-stack-line" /> {{
          dictionary.buttons.readMore }}
        ({{ count }})
      </div>
      <div class="translate" v-if="shouldShowTranlationButton" @click="$emit('translate')"><i class="ri-translate-2" />
        {{ translateLanguage }}
      </div>
    </div>

  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "NotificationDetails",
  props: ['notification', 'originalLanguage', 'isRow', 'feedType', 'isSpecial', 'aggregate', 'count'],
  computed: {
    shouldShowTranlationButton() {
      return this.systemLanguage !== 'en';
    },
    translateLanguage() {

      let languages = {
        he: 'עב',
        it: 'IT',
        ar: 'عر'
      }

      if (!this.originalLanguage) {
        return this.systemLanguage === 'en' ? languages[this.systemLanguage] : 'EN';
      } else {
        return languages[this.systemLanguage] ? languages[this.systemLanguage] : 'EN'
      }
    }
  },
  methods: {
    formatDateTime(datetime) {

      return DateTime.fromISO(datetime).setLocale(this.dateFormatLocale).toFormat('HH:mm')
      // return DateTime.fromISO(datetime).setLocale(this.dateFormatLocale).toFormat('DDD HH:mm')
    },
  }
}
</script>

<style scoped lang="scss">
.sourceName {
  color: var(--sourceNameColor);

  &.mbpAi {
    color: var(--green);
    font-weight: 600;
  }
}

.details {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;

  .aggregationLink {
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.translate {
  cursor: pointer;
  font-size: 14px;
  //margin-right: auto;
  background: var(--translateButtonBg);
  padding: 2px 5px;
  border-radius: 5px;
}

[data-theme="light"] {
  .translate {
    color: var(--textColor);
  }
}
</style>
